import { gettext } from '@eventbrite/i18n';
import { OficceInfoType } from '../../types';

interface OfficeDataStructure {
    [key: string]: OficceInfoType;
}
export const CONTACT_DATA_MENDOZA = {
    location: 'mendoza',
    name: gettext('Mendoza'),
    location_title: gettext('Mendoza, Argentina'),
    location_address: 'República del Líbano 981, Godoy Cruz, Mendoza',
    direction_url:
        'https://www.google.com.ar/maps/place/Rep%C3%BAblica+del+L%C3%ADbano+981,+Godoy+Cruz,+Mendoza/@-32.9368481,-68.8434071,17z/data=!3m1!4b1!4m5!3m4!1s0x967e0bc499014bf7:0xff67cc0bebfa15b2!8m2!3d-32.9368481!4d-68.8412184?hl=en',
};
export const CONTACT_DATA_SAN_FRANCISCO = {
    location: 'san-francisco',
    name: gettext('San Francisco'),
    location_title: gettext('San Francisco, CA'),
    location_address:
        '95 Third Street, 2nd Floor, San Francisco, California, 94103​ USA​',
    direction_url:
        'https://www.google.com/maps/place/The+Paramount,+95+3rd+St+2nd+Floor,+San+Francisco,+CA+94103,+USA/@37.7866019,-122.404758,17z/data=!3m1!4b1!4m6!3m5!1s0x80858087e4a4fdd9:0x5d54a80ea8d97eed!8m2!3d37.7866019!4d-122.4021831!16s%2Fg%2F11qpw1xwn_',
};
export const CONTANCT_DATA_MELBOURNE = {
    location: 'melbourne',
    name: gettext('Melbourne'),
    location_title: gettext('Melbourne, Australia'),
    location_address:
        'Part Level 1, 1 Southbank Boulevard, Southbank, VIC 3006',
    direction_url:
        'https://www.google.com/maps/place/1+Southbank+Blvd,+Southbank+VIC+3006,+Australia/@-37.8210041,144.9606727,17z/data=!3m1!4b1!4m5!3m4!1s0x6ad642b296ea00bf:0x313da72dd81e0378!8m2!3d-37.8210084!4d144.9628614',
};
export const CONTACT_DATA_LONDON = {
    location: 'london',
    name: gettext('London'),
    location_title: gettext('London, UK'),
    location_address: '12-18 Theobalds Road, London WC1X 8SL',
    direction_url:
        'https://www.google.com/maps/place/12-18+Theobalds+Rd,+London+WC1X+8PL,+UK/@51.521427,-0.1144347,19z/data=!4m6!3m5!1s0x48761b49ff1c3813:0x84683a658ac368f3!8m2!3d51.521445!4d-0.1141175!16s%2Fg%2F11c5fnqfbp',
};
export const CONTACT_DATA_NASHVILLE = {
    location: 'nashville',
    name: gettext('Nashville'),
    location_title: gettext('Nashville, TN'),
    location_address: '209 10th Ave. S, Suite 300 Nashville, TN 37203',
    direction_url:
        'https://www.google.com/maps/place/Cummins+Station,+209+10th+Ave+S+%23300,+Nashville,+TN+37203/@36.15515,-86.7847585,17z/data=!3m1!4b1!4m5!3m4!1s0x886466f54dbef463:0xca02666a8997dfb4!8m2!3d36.15515!4d-86.7825698',
};
export const CONTACT_DATA_MADRID = {
    location: 'madrid',
    name: gettext('Madrid'),
    location_title: gettext('Madrid, Spain'),
    location_address: 'Paseo de la Castellana, 130, Floor 9, 28046 Madrid',
    direction_url:
        'https://www.google.com/maps/place/Castellana+Bernab%C3%A9u+First/@40.4503776,-3.6926125,18z/data=!3m2!4b1!5s0xd4228e3a0e2206b:0xb89586786af60fdb!4m6!3m5!1s0xd4229271f7816f7:0xfd15cb05c6bb934b!8m2!3d40.4503776!4d-3.690177!16s%2Fg%2F11stvdfw5h',
};
export const CONTACT_DATA_CORK = {
    location: 'cork',
    name: gettext('Cork'),
    location_title: gettext('Cork, Ireland'),
    location_address: 'First Floor, Penrose One, Penrose Dock, Cork, T23 KW81',
    direction_url:
        'https://www.google.com/maps/place/Penrose+Dock/@51.9003707,-8.4614276,17.53z/data=!4m6!3m5!1s0x484491c1e2bfe1ad:0xe07bf603694939be!8m2!3d51.9002598!4d-8.4621715!16s%2Fg%2F11kxjt8fdk',
};
export const CONTACT_DATA_LOS_ANGELES = {
    location: 'los-angeles',
    name: gettext('Los Angeles'),
    location_title: gettext('Los Angeles, CA'),
    location_address:
        'The Bradbury, 304 S Broadway, Suites 415 and 420, Los Angeles',
    direction_url:
        'https://www.google.com/maps/place/Bradbury+Building/@34.0506062,-118.2491448,18z/data=!3m2!4b1!5s0x80c2c64be952df6b:0xf6ab78aea8884ced!4m6!3m5!1s0x80c2c64bf2828b05:0x955a9f0a8f53103b!8m2!3d34.050604!4d-118.2478573!16zL20vMDRoZDEy',
};
export const CONTACT_DATA_HYDERABAD = {
    location: 'hyderabad',
    name: gettext('Hyderabad'),
    location_title: gettext('Hyderabad, India'),
    location_address:
        'The Skyview, Building No. 10, SY No. 83/1, Raidurgam Plot Nos. 22, Hitech City Main Rd, Madhapur, Rangareddy District, Telangana 500081',
    direction_url:
        'https://www.google.com/maps/place/The+Skyview/@17.4308905,78.3731155,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcb93fadfe8a053:0x27710ce1bc48e4e4!8m2!3d17.4308854!4d78.3756904!16s%2Fg%2F11c0rm40b2',
};

export const OFFICE_DATA: OfficeDataStructure = {
    'san-francisco': CONTACT_DATA_SAN_FRANCISCO,
    mendoza: CONTACT_DATA_MENDOZA,
    melbourne: CONTANCT_DATA_MELBOURNE,
    london: CONTACT_DATA_LONDON,
    nashville: CONTACT_DATA_NASHVILLE,
    madrid: CONTACT_DATA_MADRID,
    cork: CONTACT_DATA_CORK,
    'los-angeles': CONTACT_DATA_LOS_ANGELES,
    hyderabad: CONTACT_DATA_HYDERABAD,
};
